var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCallSplit24DpE3E3E3Fill0Wght400Grad0Opsz24 = function SvgCallSplit24DpE3E3E3Fill0Wght400Grad0Opsz24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e3e3e3",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440-160v-304L240-664v104h-80v-240h240v80H296l224 224v336zm154-376-58-58 128-126H560v-80h240v240h-80v-104z"
  })));
};
export default SvgCallSplit24DpE3E3E3Fill0Wght400Grad0Opsz24;